import { getTextFromHTML } from "@src/store/slices/experienceBuilder/common/utils/html/getTextFromHTML";

export function getSummaryTextFromHTML(html: string | undefined) {
  const text = getTextFromHTML(html);
  return text.substring(0, 500);
}
